/** @format */
import { Heading } from '@mpb-com/feather/components/atoms/heading';
import { HeadingSize } from '@mpb-com/feather/components/atoms/heading/types';
import React, { Fragment, FunctionComponent, useContext } from 'react';
import styled from 'styled-components';

import { formatAsCurrency } from '@toucan/client/global/currency';
import { MarketContext } from '@toucan/client/global/market';

import { DEFAULT_TEST_ID } from './constants';
import { styles } from './product-price.styles';
import { ProductPriceProps } from './types';

const StyledProductPrice = styled(Heading)`
    ${styles}
`;

export const ProductPrice: FunctionComponent<ProductPriceProps> = ({
    'data-testid': dataTestId = DEFAULT_TEST_ID,
    listPrice,
    originalPrice,
    ...otherProps
}) => {
    const { activeMarket } = useContext(MarketContext);

    const formatPrice = formatAsCurrency(
        activeMarket.iso,
        activeMarket.currency
    );

    const listPriceFormatted = formatPrice(listPrice, { trailingZeros: false });
    const originalPriceFormatted =
        originalPrice && originalPrice !== listPrice
            ? formatPrice(originalPrice, { trailingZeros: false })
            : undefined;

    return (
        <StyledProductPrice
            {...otherProps}
            data-testid={dataTestId}
            size={HeadingSize.H3}
        >
            {originalPriceFormatted && (
                <Fragment>
                    <span
                        className="original-price"
                        data-testid={`${dataTestId}__original-price`}
                    >
                        {originalPriceFormatted}
                    </span>{' '}
                </Fragment>
            )}
            <span
                className="list-price"
                data-testid={`${dataTestId}__list-price`}
            >
                {listPriceFormatted}
            </span>
        </StyledProductPrice>
    );
};
